import { SET_CONNECT_LOGS } from '../actionTypes'
// import moment from 'moment'
// import _ from 'lodash'

const initialState = []

export default (state=initialState,  payload) => {
    switch(payload.type) {

    case SET_CONNECT_LOGS:
        return payload.connectLogsData || null
    
    default:
        return state
    }
}